import { useState, useEffect, useRef, useCallback } from "react";

const API = "https://demo4.enhancor.com/api/public/api";

const COLORS = {
  sidebar:"#1e1f2e", sidebarText:"#a0a3b1", sidebarActive:"#2d2f45",
  accent:"#4f6ef7", accentLight:"#eef1ff",
  vip:"#e84949", vipLight:"#fff0f0",
  rp:"#7c3aed", rpLight:"#f3f0ff",
  yardi:"#0ea5e9", yardiLight:"#f0f9ff",
  success:"#16a34a", successLight:"#f0fdf4",
  warning:"#d97706", warningLight:"#fffbeb",
  border:"#e5e7eb", bg:"#f8f9fc", cardBg:"#ffffff",
  text:"#111827", textMuted:"#6b7280", textLight:"#9ca3af",
};

const INBOXES = ["AP@fairstead.com","AP2@fairstead.com","APteam@fairstead.com","Enhancorapteam@enhancor.com"];
const VIP_KEYWORDS = ["lien","hold","suspension","disconnection","urgent","check run"];
const COMMIT_KEYWORDS = ["commit","committed","selected payment","fedex","overnight","2day"];
const VIP_SENDERS = ["hiren","chad","danny","avi","jeff","lieselle","seth","ana kelly"];
const RP_PROPS = ["realpage","camden","greystar","lincoln"];
const YARDI_PROPS = ["yardi","fairstead","enhancor","affordable"];
const CATEGORIES = ["Invoices","Check Run","New Vendors / Certs","Statements / Recon","Status of Payment","Utility / ISP"];
const AGENTS = ["Valerie","Yvette","John","Maria","Carlos","Priya","David","Nadia"];
const STATUSES = ["Open","In Progress","Pending","Resolved","Closed"];

const USERS = [
  { email:"admin@enhancor.com", password:"admin123", name:"Admin User", role:"Admin" },
  { email:"valerie@enhancor.com", password:"val123", name:"Valerie", role:"Agent" },
  { email:"john@enhancor.com", password:"john123", name:"John", role:"Agent" },
];

const INIT_USERS = [
  { id:1, name:"Admin User", email:"admin@enhancor.com", role:"Admin", status:"Active" },
  { id:2, name:"Valerie", email:"valerie@enhancor.com", role:"Agent", status:"Active" },
];

const INIT_PROPERTIES = [
  { id:1, name:"Camden Property", bucket:"RP", address:"123 Main St, New York", status:"Active" },
  { id:2, name:"Yardi Plaza", bucket:"YARDI", address:"321 Oak St, Chicago", status:"Active" },
];

function classify(email) {
  const txt = (email.subject+" "+email.body).toLowerCase();
  const sndr = email.from.toLowerCase();
  let bucket="Unassigned",isVIP=false,assignedTo=[],category="Invoices";
  if(VIP_KEYWORDS.some(k=>txt.includes(k))) isVIP=true;
  if(VIP_SENDERS.some(s=>sndr.includes(s))) isVIP=true;
  if(COMMIT_KEYWORDS.some(k=>txt.includes(k))) assignedTo=["Valerie","Yvette"];
  if(RP_PROPS.some(p=>txt.includes(p))) bucket="RP";
  else if(YARDI_PROPS.some(p=>txt.includes(p))) bucket="YARDI";
  if(txt.includes("invoice")) category="Invoices";
  else if(txt.includes("check run")) category="Check Run";
  else if(txt.includes("vendor")) category="New Vendors / Certs";
  else if(txt.includes("statement")) category="Statements / Recon";
  else if(txt.includes("payment")) category="Status of Payment";
  else if(txt.includes("utility")||txt.includes("disconnection")) category="Utility / ISP";
  if(!assignedTo.length) assignedTo=[AGENTS[Math.floor(Math.random()*6)+2]];
  return {bucket,isVIP,assignedTo,category};
}

const Avatar = ({name,size=32,color=COLORS.accent})=>(
  <div style={{width:size,height:size,borderRadius:"50%",background:color+"22",color,fontSize:size*0.36,fontWeight:500,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
    {name.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase()}
  </div>
);
const Badge=({label,color,bg})=>(
  <span style={{fontSize:11,fontWeight:500,padding:"2px 8px",borderRadius:99,background:bg,color,whiteSpace:"nowrap"}}>{label}</span>
);
const Card=({children,style={}})=>(
  <div style={{background:COLORS.cardBg,border:`1px solid ${COLORS.border}`,borderRadius:12,...style}}>{children}</div>
);
const bucketBadge=b=>b==="RP"?<Badge label="RP" color={COLORS.rp} bg={COLORS.rpLight}/>:b==="YARDI"?<Badge label="YARDI" color={COLORS.yardi} bg={COLORS.yardiLight}/>:<Badge label="—" color={COLORS.textMuted} bg={COLORS.bg}/>;
const statusBadge=s=>{const map={Open:[COLORS.accent,COLORS.accentLight],"In Progress":[COLORS.warning,COLORS.warningLight],Pending:["#9333ea","#f3e8ff"],Resolved:[COLORS.success,COLORS.successLight],Closed:[COLORS.textMuted,"#f3f4f6"]};const[c,bg]=map[s]||[COLORS.textMuted,"#f3f4f6"];return<Badge label={s} color={c} bg={bg}/>;};

// ── DropdownReply ─────────────────────────────────────────────────────────────
function DropdownReply({ticket,showToast,onReplySent}){
  const [open,setOpen]=useState(false);
  const [replyText,setReplyText]=useState("");
  const [replyType,setReplyType]=useState("reply");
  const [cc,setCc]=useState("");
  const [sending,setSending]=useState(false);
  const [showCC,setShowCC]=useState(false);
  const ref=useRef(null);

  useEffect(()=>{
    const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    document.addEventListener('mousedown',h);
    return()=>document.removeEventListener('mousedown',h);
  },[]);

  const send=async()=>{
    if(!replyText.trim()) return showToast("Type a reply first");
    setSending(true);
    try{
      const res=await fetch(`${API}/tickets/${ticket.id}/reply`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({body:replyText,reply_type:replyType,cc:cc?cc.split(',').map(e=>e.trim()).filter(Boolean):[]})});
      const data=await res.json();
      if(res.ok){showToast("✅ Reply sent!");onReplySent(`\n\n--- Sent reply to ${ticket.from} ---\n${replyText}`);setReplyText("");setCc("");setOpen(false);}
      else showToast("❌ "+(data.message||"Failed"));
    }catch(e){showToast("❌ "+e.message);}
    setSending(false);
  };

  return(
    <div ref={ref} style={{position:"relative"}}>
      <div style={{display:"flex",gap:2}}>
        <button onClick={()=>{setOpen(p=>!p);setReplyType("reply");}} style={{display:"flex",alignItems:"center",gap:6,padding:"7px 14px",borderRadius:"8px 0 0 8px",border:`1.5px solid ${COLORS.accent}`,background:COLORS.accent,color:"#fff",fontSize:12,cursor:"pointer",fontWeight:600}}>
          ↩ Reply All
        </button>
        <button onClick={()=>{setOpen(p=>!p);setReplyType("reply_all");}} style={{padding:"7px 10px",borderRadius:"0 8px 8px 0",border:`1.5px solid ${COLORS.accent}`,borderLeft:`1px solid #6b85f8`,background:COLORS.accent,color:"#fff",fontSize:12,cursor:"pointer"}}>
          ▼
        </button>
      </div>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 8px)",right:0,width:520,background:COLORS.cardBg,border:`1.5px solid ${COLORS.border}`,borderRadius:12,boxShadow:"0 8px 32px rgba(0,0,0,.15)",zIndex:300,padding:20}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontSize:13,fontWeight:600,color:COLORS.text}}>New Reply</div>
            <div style={{display:"flex",gap:6}}>
              <button onClick={()=>setReplyType("reply")} style={{padding:"4px 10px",borderRadius:6,border:`1px solid ${replyType==="reply"?COLORS.accent:COLORS.border}`,background:replyType==="reply"?COLORS.accentLight:"transparent",color:replyType==="reply"?COLORS.accent:COLORS.textMuted,fontSize:11,cursor:"pointer"}}>↩ Reply</button>
              <button onClick={()=>setReplyType("reply_all")} style={{padding:"4px 10px",borderRadius:6,border:`1px solid ${replyType==="reply_all"?COLORS.accent:COLORS.border}`,background:replyType==="reply_all"?COLORS.accentLight:"transparent",color:replyType==="reply_all"?COLORS.accent:COLORS.textMuted,fontSize:11,cursor:"pointer"}}>↩↩ Reply All</button>
              <button onClick={()=>setShowCC(p=>!p)} style={{padding:"4px 10px",borderRadius:6,border:`1px solid ${showCC?COLORS.accent:COLORS.border}`,background:showCC?COLORS.accentLight:"transparent",color:showCC?COLORS.accent:COLORS.textMuted,fontSize:11,cursor:"pointer"}}>+ CC</button>
              <button onClick={()=>setOpen(false)} style={{padding:"4px 8px",borderRadius:6,border:"none",background:"transparent",color:COLORS.textMuted,fontSize:14,cursor:"pointer"}}>×</button>
            </div>
          </div>
          <div style={{background:COLORS.bg,borderRadius:8,padding:"8px 12px",marginBottom:8,fontSize:12}}>
            <span style={{color:COLORS.textMuted,fontWeight:500}}>To: </span><span style={{color:COLORS.text}}>{ticket.from}</span>
            {replyType==="reply_all"&&<span style={{color:COLORS.accent,marginLeft:8,fontSize:11}}>+ all recipients</span>}
          </div>
          {showCC&&(
            <div style={{background:COLORS.bg,borderRadius:8,padding:"4px 12px",marginBottom:8}}>
              <span style={{color:COLORS.textMuted,fontWeight:500,fontSize:12}}>CC: </span>
              <input value={cc} onChange={e=>setCc(e.target.value)} placeholder="email1, email2..." style={{border:"none",outline:"none",fontSize:12,background:"transparent",width:"80%",color:COLORS.text}}/>
            </div>
          )}
          <textarea value={replyText} onChange={e=>setReplyText(e.target.value)} placeholder="Type your reply here..." rows={6} autoFocus style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"10px 12px",fontSize:12,outline:"none",resize:"vertical",fontFamily:"system-ui,sans-serif",boxSizing:"border-box",color:COLORS.text,marginBottom:12}}/>
          <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
            <button onClick={()=>{setReplyText("");setOpen(false);}} style={{padding:"8px 16px",borderRadius:8,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,fontSize:12,cursor:"pointer"}}>Cancel</button>
            <button onClick={send} disabled={sending} style={{padding:"8px 24px",borderRadius:8,border:"none",background:sending?COLORS.textLight:COLORS.accent,color:"#fff",fontSize:12,fontWeight:600,cursor:sending?"not-allowed":"pointer"}}>
              {sending?"Sending...":"Send Reply →"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── DropdownActions ───────────────────────────────────────────────────────────
function DropdownActions({ticket,updateTicket,showToast}){
  const [open,setOpen]=useState(false);
  const ref=useRef(null);

  useEffect(()=>{
    const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false);};
    document.addEventListener('mousedown',h);
    return()=>document.removeEventListener('mousedown',h);
  },[]);

  return(
    <div ref={ref} style={{position:"relative"}}>
      <button onClick={()=>setOpen(p=>!p)} style={{padding:"7px 14px",borderRadius:8,border:`1px solid ${COLORS.border}`,background:COLORS.cardBg,color:COLORS.text,fontSize:12,cursor:"pointer",fontWeight:500,display:"flex",alignItems:"center",gap:6}}>
        ⚙ Actions {open?"▲":"▼"}
      </button>
      {open&&(
        <div style={{position:"absolute",top:"calc(100% + 8px)",right:0,width:340,background:COLORS.cardBg,border:`1px solid ${COLORS.border}`,borderRadius:12,boxShadow:"0 8px 32px rgba(0,0,0,.15)",zIndex:300,padding:16}}>
          <div style={{fontSize:12,fontWeight:600,color:COLORS.text,marginBottom:12}}>Update Ticket</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:12}}>
            {[["Status",STATUSES,"status"],["Bucket",["RP","YARDI","Unassigned"],"bucket"],["Assigned",AGENTS,"assignedTo"]].map(([lbl,opts,key])=>(
              <div key={key}>
                <div style={{fontSize:10,color:COLORS.textMuted,marginBottom:3}}>{lbl}</div>
                <select value={key==="assignedTo"?(Array.isArray(ticket.assignedTo)?ticket.assignedTo[0]:ticket.assignedTo):ticket[key]} onChange={e=>updateTicket(ticket.id,{[key]:key==="assignedTo"?[e.target.value]:e.target.value})} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"5px 6px",fontSize:11,background:COLORS.bg,color:COLORS.text,outline:"none"}}>
                  {opts.map(o=><option key={o}>{o}</option>)}
                </select>
              </div>
            ))}
          </div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <button onClick={()=>{updateTicket(ticket.id,{isVIP:!ticket.isVIP});setOpen(false);}} style={{padding:"6px 12px",borderRadius:8,border:`1px solid ${ticket.isVIP?COLORS.vip:COLORS.border}`,background:ticket.isVIP?COLORS.vipLight:"transparent",color:ticket.isVIP?COLORS.vip:COLORS.textMuted,fontSize:11,cursor:"pointer"}}>{ticket.isVIP?"Remove VIP":"⚡ VIP"}</button>
            <button onClick={()=>{updateTicket(ticket.id,{status:"In Progress"});showToast("In progress!");setOpen(false);}} style={{padding:"6px 12px",borderRadius:8,border:`1px solid ${COLORS.warning}`,background:COLORS.warningLight,color:COLORS.warning,fontSize:11,cursor:"pointer"}}>◑ In Progress</button>
            <button onClick={()=>{updateTicket(ticket.id,{status:"Resolved"});showToast("Resolved!");setOpen(false);}} style={{padding:"6px 12px",borderRadius:8,border:`1px solid ${COLORS.success}`,background:COLORS.successLight,color:COLORS.success,fontSize:11,cursor:"pointer"}}>✓ Resolve</button>
            <button onClick={()=>{updateTicket(ticket.id,{status:"Closed"});showToast("Closed.");setOpen(false);}} style={{padding:"6px 12px",borderRadius:8,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,fontSize:11,cursor:"pointer"}}>✕ Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

function UsersPage(){
  const [users,setUsers]=useState([]);
  const [showModal,setShowModal]=useState(false);
  const [editUser,setEditUser]=useState(null);
  const [form,setForm]=useState({name:"",email:"",password:"",role:"Agent",status:"Active"});
  const [toast,setToast]=useState("");
  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(""),3000);};
  const fetchUsers=async()=>{try{const res=await fetch(`${API}/users`);const data=await res.json();setUsers(data.length?data:INIT_USERS);}catch(e){setUsers(INIT_USERS);}};
  useEffect(()=>{fetchUsers();},[]);
  const openAdd=()=>{setForm({name:"",email:"",password:"",role:"Agent",status:"Active"});setEditUser(null);setShowModal(true);};
  const openEdit=u=>{setForm({name:u.name,email:u.email,password:"",role:u.role,status:u.status});setEditUser(u);setShowModal(true);};
  const saveUser=async()=>{
    if(!form.name||!form.email) return showToast("Fill all fields");
    if(!form.email.includes('@')) return showToast("Enter a valid email!");
    try{
      if(editUser){await fetch(`${API}/users/${editUser.id}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});showToast("User updated!");}
      else{if(!form.password) return showToast("Password required!");await fetch(`${API}/users`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});showToast("User added!");}
      fetchUsers();
    }catch(e){showToast("Error: "+e.message);}
    setShowModal(false);
  };
  const toggleStatus=async u=>{try{await fetch(`${API}/users/${u.id}/toggle-status`,{method:'PATCH'});fetchUsers();showToast(`User ${u.status==="Active"?"deactivated":"activated"}!`);}catch(e){showToast("Error");}};
  return(
    <div>
      {toast&&<div style={{position:"fixed",top:16,right:16,zIndex:999,background:"#1e1f2e",color:"#fff",padding:"10px 16px",borderRadius:8,fontSize:12}}>{toast}</div>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{fontSize:14,fontWeight:500,color:COLORS.text}}>All Users ({users.length})</div>
        <button onClick={openAdd} style={{background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:500,cursor:"pointer"}}>+ Add User</button>
      </div>
      <Card>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead><tr style={{background:COLORS.bg,borderBottom:`1px solid ${COLORS.border}`}}>{["Name","Email","Role","Status","Actions"].map(h=><th key={h} style={{padding:"10px 16px",textAlign:"left",fontWeight:500,color:COLORS.textMuted,fontSize:12}}>{h}</th>)}</tr></thead>
          <tbody>
            {users.map(u=>(
              <tr key={u.id} style={{borderBottom:`1px solid ${COLORS.border}`}}>
                <td style={{padding:"12px 16px"}}><div style={{display:"flex",alignItems:"center",gap:10}}><Avatar name={u.name} size={32} color={COLORS.accent}/><span style={{fontWeight:500,color:COLORS.text}}>{u.name}</span></div></td>
                <td style={{padding:"12px 16px",color:COLORS.textMuted}}>{u.email}</td>
                <td style={{padding:"12px 16px"}}><Badge label={u.role} color={u.role==="Admin"?COLORS.vip:COLORS.accent} bg={u.role==="Admin"?COLORS.vipLight:COLORS.accentLight}/></td>
                <td style={{padding:"12px 16px"}}><Badge label={u.status} color={u.status==="Active"?COLORS.success:COLORS.textMuted} bg={u.status==="Active"?COLORS.successLight:"#f3f4f6"}/></td>
                <td style={{padding:"12px 16px"}}><div style={{display:"flex",gap:8}}>
                  <button onClick={()=>openEdit(u)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.accent,fontSize:11,cursor:"pointer"}}>Edit</button>
                  <button onClick={()=>toggleStatus(u)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${COLORS.border}`,background:"transparent",color:u.status==="Active"?COLORS.vip:COLORS.success,fontSize:11,cursor:"pointer"}}>{u.status==="Active"?"Deactivate":"Activate"}</button>
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      {showModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:50}}>
          <Card style={{width:420,padding:24}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontWeight:500,fontSize:15,color:COLORS.text}}>{editUser?"Edit User":"Add New User"}</div>
              <button onClick={()=>setShowModal(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:COLORS.textMuted}}>×</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {[["Name","name","text","Full name"],["Email","email","email","email@enhancor.com"],["Password","password","password","Min 6 characters"]].map(([l,k,t,ph])=>(
                <div key={k}><div style={{fontSize:12,color:COLORS.textMuted,marginBottom:4}}>{l}</div><input type={t} value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,outline:"none",boxSizing:"border-box",background:COLORS.bg,color:COLORS.text}}/></div>
              ))}
              {[["Role","role",["Admin","Agent","Viewer"]],["Status","status",["Active","Inactive"]]].map(([l,k,opts])=>(
                <div key={k}><div style={{fontSize:12,color:COLORS.textMuted,marginBottom:4}}>{l}</div><select value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,background:COLORS.bg,color:COLORS.text,outline:"none"}}>{opts.map(o=><option key={o}>{o}</option>)}</select></div>
              ))}
              <div style={{display:"flex",gap:8,paddingTop:4}}>
                <button onClick={()=>setShowModal(false)} style={{flex:1,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,borderRadius:8,padding:"8px",fontSize:12,cursor:"pointer"}}>Cancel</button>
                <button onClick={saveUser} style={{flex:1,background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px",fontSize:12,fontWeight:500,cursor:"pointer"}}>Save</button>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}

function PropertiesPage(){
  const [properties,setProperties]=useState([]);
  const [showModal,setShowModal]=useState(false);
  const [showBulk,setShowBulk]=useState(false);
  const [editProp,setEditProp]=useState(null);
  const [form,setForm]=useState({name:"",bucket:"RP",address:"",status:"Active"});
  const [toast,setToast]=useState("");
  const [filterBucket,setFilterBucket]=useState("All");
  const [csvData,setCsvData]=useState([]);
  const [csvError,setCsvError]=useState("");
  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(""),3000);};
  const fetchProperties=async()=>{try{const url=filterBucket==="All"?`${API}/properties`:`${API}/properties?bucket=${filterBucket}`;const res=await fetch(url);const data=await res.json();setProperties(data.length?data:INIT_PROPERTIES);}catch(e){setProperties(INIT_PROPERTIES);}};
  useEffect(()=>{fetchProperties();},[filterBucket]);
  const openAdd=()=>{setForm({name:"",bucket:"RP",address:"",status:"Active"});setEditProp(null);setShowModal(true);};
  const openEdit=p=>{setForm({name:p.name,bucket:p.bucket,address:p.address,status:p.status});setEditProp(p);setShowModal(true);};
  const saveProp=async()=>{
    if(!form.name||!form.address) return showToast("Fill all fields");
    try{
      if(editProp){await fetch(`${API}/properties/${editProp.id}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});showToast("Property updated!");}
      else{await fetch(`${API}/properties`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});showToast("Property added!");}
      fetchProperties();
    }catch(e){showToast("Error: "+e.message);}
    setShowModal(false);
  };
  const toggleStatus=async p=>{try{await fetch(`${API}/properties/${p.id}/toggle-status`,{method:'PATCH'});fetchProperties();showToast(`Property ${p.status==="Active"?"deactivated":"activated"}!`);}catch(e){showToast("Error");}};
  const handleCSV=e=>{
    const file=e.target.files[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>{
      const lines=ev.target.result.split('\n').filter(l=>l.trim());
      const headers=lines[0].toLowerCase().split(',').map(h=>h.trim());
      const ni=headers.indexOf('name'),bi=headers.indexOf('bucket'),ai=headers.indexOf('address');
      if(ni===-1||bi===-1){setCsvError("CSV must have 'name' and 'bucket' columns!");return;}
      const rows=lines.slice(1).map(line=>{const cols=line.split(',').map(c=>c.trim());return{name:cols[ni]||'',bucket:cols[bi]||'RP',address:ai!==-1?cols[ai]||'':'',status:'Active'};}).filter(r=>r.name);
      setCsvData(rows);setCsvError("");
    };
    reader.readAsText(file);
  };
  const uploadBulk=async()=>{
    if(!csvData.length) return showToast("No data!");
    let s=0;for(const p of csvData){try{await fetch(`${API}/properties`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(p)});s++;}catch(e){}}
    showToast(`${s} properties added!`);setShowBulk(false);setCsvData([]);fetchProperties();
  };
  return(
    <div>
      {toast&&<div style={{position:"fixed",top:16,right:16,zIndex:999,background:"#1e1f2e",color:"#fff",padding:"10px 16px",borderRadius:8,fontSize:12}}>{toast}</div>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{fontSize:14,fontWeight:500,color:COLORS.text}}>All Properties ({properties.length})</div>
          <select value={filterBucket} onChange={e=>setFilterBucket(e.target.value)} style={{border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"6px 10px",fontSize:12,background:COLORS.bg,color:COLORS.text,outline:"none"}}>{["All","RP","YARDI"].map(o=><option key={o}>{o}</option>)}</select>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button onClick={openAdd} style={{background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:500,cursor:"pointer"}}>+ Add Property</button>
          <button onClick={()=>{setShowBulk(true);setCsvData([]);setCsvError("");}} style={{background:COLORS.success,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:500,cursor:"pointer"}}>⬆ Bulk Upload</button>
        </div>
      </div>
      <Card>
        <table style={{width:"100%",borderCollapse:"collapse",fontSize:13}}>
          <thead><tr style={{background:COLORS.bg,borderBottom:`1px solid ${COLORS.border}`}}>{["Name","Bucket","Address","Status","Actions"].map(h=><th key={h} style={{padding:"10px 16px",textAlign:"left",fontWeight:500,color:COLORS.textMuted,fontSize:12}}>{h}</th>)}</tr></thead>
          <tbody>
            {properties.map(p=>(
              <tr key={p.id} style={{borderBottom:`1px solid ${COLORS.border}`}}>
                <td style={{padding:"12px 16px",fontWeight:500,color:COLORS.text}}>{p.name}</td>
                <td style={{padding:"12px 16px"}}>{bucketBadge(p.bucket)}</td>
                <td style={{padding:"12px 16px",color:COLORS.textMuted}}>{p.address}</td>
                <td style={{padding:"12px 16px"}}><Badge label={p.status} color={p.status==="Active"?COLORS.success:COLORS.textMuted} bg={p.status==="Active"?COLORS.successLight:"#f3f4f6"}/></td>
                <td style={{padding:"12px 16px"}}><div style={{display:"flex",gap:8}}>
                  <button onClick={()=>openEdit(p)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.accent,fontSize:11,cursor:"pointer"}}>Edit</button>
                  <button onClick={()=>toggleStatus(p)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${COLORS.border}`,background:"transparent",color:p.status==="Active"?COLORS.vip:COLORS.success,fontSize:11,cursor:"pointer"}}>{p.status==="Active"?"Deactivate":"Activate"}</button>
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
      {showModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:50}}>
          <Card style={{width:420,padding:24}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontWeight:500,fontSize:15,color:COLORS.text}}>{editProp?"Edit Property":"Add New Property"}</div>
              <button onClick={()=>setShowModal(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:COLORS.textMuted}}>×</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {[["Name","name","text","Property name"],["Address","address","text","123 Main St, City"]].map(([l,k,t,ph])=>(
                <div key={k}><div style={{fontSize:12,color:COLORS.textMuted,marginBottom:4}}>{l}</div><input type={t} value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,outline:"none",boxSizing:"border-box",background:COLORS.bg,color:COLORS.text}}/></div>
              ))}
              {[["Bucket","bucket",["RP","YARDI"]],["Status","status",["Active","Inactive"]]].map(([l,k,opts])=>(
                <div key={k}><div style={{fontSize:12,color:COLORS.textMuted,marginBottom:4}}>{l}</div><select value={form[k]} onChange={e=>setForm(p=>({...p,[k]:e.target.value}))} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:13,background:COLORS.bg,color:COLORS.text,outline:"none"}}>{opts.map(o=><option key={o}>{o}</option>)}</select></div>
              ))}
              <div style={{display:"flex",gap:8,paddingTop:4}}>
                <button onClick={()=>setShowModal(false)} style={{flex:1,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,borderRadius:8,padding:"8px",fontSize:12,cursor:"pointer"}}>Cancel</button>
                <button onClick={saveProp} style={{flex:1,background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px",fontSize:12,fontWeight:500,cursor:"pointer"}}>Save</button>
              </div>
            </div>
          </Card>
        </div>
      )}
      {showBulk&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:50}}>
          <Card style={{width:520,padding:24}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontWeight:500,fontSize:15,color:COLORS.text}}>Bulk Upload Properties</div>
              <button onClick={()=>setShowBulk(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:COLORS.textMuted}}>×</button>
            </div>
            <div style={{background:COLORS.bg,borderRadius:8,padding:12,marginBottom:14,fontSize:12,color:COLORS.textMuted}}>
              <div style={{fontWeight:500,color:COLORS.text,marginBottom:6}}>CSV Format:</div>
              <code style={{fontSize:11,display:"block"}}>name,bucket,address</code>
            </div>
            <div style={{marginBottom:14}}>
              <input type="file" accept=".csv" onChange={handleCSV} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px",fontSize:12,background:COLORS.bg}}/>
            </div>
            {csvError&&<div style={{fontSize:12,color:COLORS.vip,background:COLORS.vipLight,padding:"8px 12px",borderRadius:8,marginBottom:14}}>{csvError}</div>}
            {csvData.length>0&&(
              <div style={{marginBottom:14}}>
                <div style={{fontSize:12,fontWeight:500,color:COLORS.text,marginBottom:8}}>Preview ({csvData.length} properties):</div>
                <div style={{maxHeight:160,overflowY:"auto",border:`1px solid ${COLORS.border}`,borderRadius:8}}>
                  <table style={{width:"100%",borderCollapse:"collapse",fontSize:11}}>
                    <thead><tr style={{background:COLORS.bg}}>{["Name","Bucket","Address"].map(h=><th key={h} style={{padding:"6px 10px",textAlign:"left",color:COLORS.textMuted}}>{h}</th>)}</tr></thead>
                    <tbody>{csvData.map((p,i)=><tr key={i} style={{borderTop:`1px solid ${COLORS.border}`}}><td style={{padding:"6px 10px",color:COLORS.text}}>{p.name}</td><td style={{padding:"6px 10px"}}>{bucketBadge(p.bucket)}</td><td style={{padding:"6px 10px",color:COLORS.textMuted}}>{p.address}</td></tr>)}</tbody>
                  </table>
                </div>
              </div>
            )}
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>setShowBulk(false)} style={{flex:1,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,borderRadius:8,padding:"8px",fontSize:12,cursor:"pointer"}}>Cancel</button>
              <button onClick={uploadBulk} disabled={!csvData.length} style={{flex:1,background:csvData.length?COLORS.success:COLORS.border,color:"#fff",border:"none",borderRadius:8,padding:"8px",fontSize:12,fontWeight:500,cursor:csvData.length?"pointer":"not-allowed"}}>Upload {csvData.length>0?`(${csvData.length})`:''}</button>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}

export default function App(){
  const [user,setUser]=useState(()=>{try{const s=localStorage.getItem("ap_user");return s?JSON.parse(s):null;}catch(e){return null;}});
  const [loginForm,setLoginForm]=useState({email:"",password:""});
  const [loginError,setLoginError]=useState("");
  const [tickets,setTickets]=useState([]);
  const [totalTickets,setTotalTickets]=useState(0);
  const [currentPage,setCurrentPage]=useState(1);
  const [lastPage,setLastPage]=useState(1);
  const [loading,setLoading]=useState(false);
  const [page,setPage]=useState("dashboard");
  const [selected,setSelected]=useState(null);
  const [filters,setFilters]=useState({bucket:"All",status:"All",search:""});
  const [compose,setCompose]=useState(false);
  const [draft,setDraft]=useState({from:"",to:INBOXES[0],subject:"",body:""});
  const [toast,setToast]=useState("");
  const [sidebarOpen,setSidebarOpen]=useState(true);
  const detailRef=useRef(null);
  const searchTimer=useRef(null);

  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(""),3000);};

  useEffect(()=>{if(selected&&detailRef.current)detailRef.current.scrollTop=0;},[selected]);

  const fetchTickets=useCallback(async(f=filters,p=1)=>{
    setLoading(true);
    try{
      const params=new URLSearchParams({per_page:200,page:p});
      if(f.search) params.append('search',f.search);
      if(f.bucket&&f.bucket!=='All') params.append('bucket',f.bucket);
      if(f.status&&f.status!=='All') params.append('status',f.status);
      const res=await fetch(`${API}/tickets?${params}`);
      const data=await res.json();
      const mapped=(data.data||[]).map(t=>({...t,assignedTo:t.assigned_to?t.assigned_to.split(','):['Unassigned'],isVIP:t.is_vip===1||t.is_vip===true,date:t.created_at}));
      if(p===1)setTickets(mapped);else setTickets(prev=>[...prev,...mapped]);
      setTotalTickets(data.total||0);
      setCurrentPage(data.current_page||1);
      setLastPage(data.last_page||1);
    }catch(e){console.log('API error:',e);}
    setLoading(false);
  },[]);

  useEffect(()=>{if(user)fetchTickets();},[user]);

  useEffect(()=>{
    if(!user)return;
    clearTimeout(searchTimer.current);
    searchTimer.current=setTimeout(()=>fetchTickets(filters,1),500);
    return()=>clearTimeout(searchTimer.current);
  },[filters]);

  const handleLogin=()=>{
    const found=USERS.find(u=>u.email===loginForm.email&&u.password===loginForm.password);
    if(found){setUser(found);setLoginError("");try{localStorage.setItem("ap_user",JSON.stringify(found));}catch(e){}}
    else setLoginError("Invalid email or password.");
  };

  const signOut=()=>{setUser(null);try{localStorage.removeItem("ap_user");}catch(e){}};

  const updateTicket=(id,changes)=>{
    setTickets(p=>p.map(t=>t.id===id?{...t,...changes}:t));
    setSelected(p=>p?.id===id?{...p,...changes}:p);
  };

  const submitEmail=async()=>{
    if(!draft.from||!draft.subject||!draft.body) return showToast("Fill all fields");
    try{
      const res=await fetch(`${API}/tickets`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(draft)});
      const data=await res.json();
      const t={...data.ticket,assignedTo:data.ticket.assigned_to?data.ticket.assigned_to.split(','):['Unassigned'],isVIP:data.ticket.is_vip===1||data.ticket.is_vip===true,date:data.ticket.created_at};
      setTickets(p=>[t,...p]);showToast(`Ticket created → ${t.bucket}${t.isVIP?" ⚡ VIP":""}`);
    }catch(e){
      const id=`TKT-${1000+tickets.length}`;
      const t={...draft,id,date:new Date().toISOString(),status:"Open",...classify(draft)};
      setTickets(p=>[t,...p]);showToast(`Ticket created (offline)`);
    }
    setDraft({from:"",to:INBOXES[0],subject:"",body:""});setCompose(false);
  };

  const goTickets=f=>{setFilters(f);setSelected(null);setPage("tickets");};

  const stats={
    total:totalTickets,
    open:tickets.filter(t=>t.status==="Open").length,
    vip:tickets.filter(t=>t.isVIP).length,
    rp:tickets.filter(t=>t.bucket==="RP").length,
    yardi:tickets.filter(t=>t.bucket==="YARDI").length,
    resolved:tickets.filter(t=>t.status==="Resolved"||t.status==="Closed").length,
    inProgress:tickets.filter(t=>t.status==="In Progress").length,
    pending:tickets.filter(t=>t.status==="Pending").length,
  };

  if(!user) return(
    <div style={{minHeight:"100vh",background:"#f0f4ff",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"system-ui,sans-serif",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",top:"-100px",left:"-100px",width:400,height:400,borderRadius:"50%",background:"#4f6ef710",pointerEvents:"none"}}></div>
      <div style={{position:"absolute",bottom:"-80px",right:"-80px",width:350,height:350,borderRadius:"50%",background:"#7c3aed10",pointerEvents:"none"}}></div>
      <div style={{width:"100%",maxWidth:440,padding:24,position:"relative",zIndex:1}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{width:64,height:64,background:COLORS.accent,borderRadius:18,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:24,fontWeight:700,margin:"0 auto 16px"}}>AP</div>
          <div style={{fontSize:24,fontWeight:700,color:COLORS.text}}>AP Ticketing System</div>
          <div style={{fontSize:13,color:COLORS.textMuted,marginTop:6}}>Fairstead · Enhancor · Accounts Payable</div>
        </div>
        <div style={{background:"#fff",border:`1px solid ${COLORS.border}`,borderRadius:16,padding:32}}>
          <div style={{fontSize:15,fontWeight:600,color:COLORS.text,marginBottom:6}}>Welcome back!</div>
          <div style={{fontSize:13,color:COLORS.textMuted,marginBottom:22}}>Sign in to your account to continue</div>
          <div style={{marginBottom:14}}>
            <div style={{fontSize:12,color:COLORS.textMuted,marginBottom:5,fontWeight:500}}>Email address</div>
            <input type="email" placeholder="you@enhancor.com" value={loginForm.email} onChange={e=>setLoginForm(p=>({...p,email:e.target.value}))} style={{width:"100%",border:`1.5px solid ${COLORS.border}`,borderRadius:9,padding:"11px 14px",fontSize:13,outline:"none",boxSizing:"border-box",color:COLORS.text,background:"#fafafa"}}/>
          </div>
          <div style={{marginBottom:18}}>
            <div style={{fontSize:12,color:COLORS.textMuted,marginBottom:5,fontWeight:500}}>Password</div>
            <input type="password" placeholder="••••••••" value={loginForm.password} onChange={e=>setLoginForm(p=>({...p,password:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&handleLogin()} style={{width:"100%",border:`1.5px solid ${COLORS.border}`,borderRadius:9,padding:"11px 14px",fontSize:13,outline:"none",boxSizing:"border-box",color:COLORS.text,background:"#fafafa"}}/>
          </div>
          {loginError&&<div style={{fontSize:12,color:COLORS.vip,background:COLORS.vipLight,border:`1px solid #fecaca`,padding:"9px 12px",borderRadius:8,marginBottom:14}}>{loginError}</div>}
          <button onClick={handleLogin} style={{width:"100%",background:COLORS.accent,color:"#fff",border:"none",borderRadius:9,padding:"12px",fontSize:14,fontWeight:600,cursor:"pointer"}}>Sign in →</button>
        </div>
        <div style={{textAlign:"center",marginTop:16,fontSize:11,color:COLORS.textLight}}>AP Ticketing System v1.0 · Enhancor</div>
      </div>
    </div>
  );

  const navItems=[
    {id:"dashboard",icon:"▤",label:"Dashboard"},
    {id:"tickets",icon:"◈",label:"All Tickets"},
    {id:"inboxes",icon:"✉",label:"Inboxes"},
    {id:"agents",icon:"◉",label:"Agents"},
    {id:"reports",icon:"◫",label:"Reports"},
    {id:"users",icon:"👤",label:"Users"},
    {id:"properties",icon:"🏢",label:"Properties"},
  ];

  return(
    <div style={{display:"flex",minHeight:"100vh",fontFamily:"system-ui,sans-serif",fontSize:13,background:COLORS.bg}}>
      {toast&&<div style={{position:"fixed",top:16,right:16,zIndex:999,background:"#1e1f2e",color:"#fff",padding:"10px 16px",borderRadius:8,fontSize:12}}>{toast}</div>}

      {sidebarOpen&&(
        <div style={{width:200,background:COLORS.sidebar,display:"flex",flexDirection:"column",padding:"16px 10px",position:"fixed",top:0,left:0,bottom:0,zIndex:100}}>
          <div style={{display:"flex",alignItems:"center",gap:8,padding:"0 4px 20px"}}>
            <div style={{width:28,height:28,background:COLORS.accent,borderRadius:7,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:12,fontWeight:700}}>AP</div>
            <div>
              <div style={{color:"#fff",fontWeight:600,fontSize:13,lineHeight:1.2}}>AP Tickets</div>
              <div style={{color:COLORS.sidebarText,fontSize:10}}>Fairstead · Enhancor</div>
            </div>
          </div>
          <div style={{flex:1,display:"flex",flexDirection:"column",gap:2}}>
            {navItems.map(n=>{
              const active=page===n.id;
              return(
                <button key={n.id} onClick={()=>{setPage(n.id);setSelected(null);}} style={{display:"flex",alignItems:"center",gap:10,padding:"9px 14px",borderRadius:8,cursor:"pointer",color:active?"#fff":COLORS.sidebarText,background:active?COLORS.sidebarActive:"transparent",fontSize:13,fontWeight:active?500:400,border:"none",textAlign:"left",width:"100%"}}>
                  <span style={{fontSize:14,width:16}}>{n.icon}</span>{n.label}
                  {n.id==="tickets"&&stats.open>0&&<span style={{marginLeft:"auto",background:COLORS.accent,color:"#fff",fontSize:10,fontWeight:600,padding:"1px 6px",borderRadius:99}}>{stats.open}</span>}
                </button>
              );
            })}
          </div>
          <div style={{borderTop:"1px solid #2d2f45",paddingTop:12}}>
            <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 14px"}}>
              <Avatar name={user.name} size={26} color={COLORS.accent}/>
              <div>
                <div style={{color:"#fff",fontSize:11,fontWeight:500}}>{user.name}</div>
                <div style={{color:COLORS.sidebarText,fontSize:10}}>{user.role}</div>
              </div>
            </div>
            <button onClick={signOut} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 14px",borderRadius:8,cursor:"pointer",color:COLORS.sidebarText,fontSize:11,background:"none",border:"none",width:"100%"}}>
              <span style={{fontSize:12}}>⏻</span> Sign out
            </button>
          </div>
        </div>
      )}

      <div style={{flex:1,marginLeft:sidebarOpen?200:0}}>
        <div style={{background:COLORS.cardBg,borderBottom:`1px solid ${COLORS.border}`,padding:"10px 20px",display:"flex",alignItems:"center",gap:12,position:"sticky",top:0,zIndex:99}}>
          <button onClick={()=>setSidebarOpen(p=>!p)} style={{background:"none",border:"none",cursor:"pointer",fontSize:16,color:COLORS.textMuted,padding:4}}>☰</button>
          <div style={{flex:1,fontSize:14,fontWeight:500,color:COLORS.text}}>
            {{dashboard:"Dashboard",tickets:"All Tickets",inboxes:"Inboxes",agents:"Agents",reports:"Reports",users:"Users",properties:"Properties"}[page]}
            {loading&&<span style={{fontSize:11,color:COLORS.textMuted,marginLeft:8}}>Loading...</span>}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:6,fontSize:11,background:COLORS.successLight,color:COLORS.success,padding:"4px 10px",borderRadius:99}}>
            <div style={{width:6,height:6,borderRadius:"50%",background:COLORS.success}}></div> Outlook connected
          </div>
          <button onClick={()=>setCompose(true)} style={{background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"7px 14px",fontSize:12,fontWeight:500,cursor:"pointer"}}>+ Simulate Email</button>
        </div>

        <div style={{padding:20}}>

          {/* DASHBOARD */}
          {page==="dashboard"&&<>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
              <div>
                <div style={{fontSize:18,fontWeight:600,color:COLORS.text}}>Welcome back, {user.name} 👋</div>
                <div style={{fontSize:12,color:COLORS.textMuted,marginTop:2}}>Here's what's happening with your tickets today</div>
              </div>
              <div style={{fontSize:11,color:COLORS.textMuted,background:COLORS.bg,border:`1px solid ${COLORS.border}`,padding:"6px 12px",borderRadius:8}}>April 08, 2026</div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(7,1fr)",gap:10,marginBottom:20}}>
              {[["Total",stats.total,COLORS.text,"◈",{bucket:"All",status:"All",search:""}],["Open",stats.open,COLORS.accent,"○",{bucket:"All",status:"Open",search:""}],["In Progress",stats.inProgress,COLORS.warning,"◑",{bucket:"All",status:"In Progress",search:""}],["VIP",stats.vip,COLORS.vip,"⚡",{bucket:"All",status:"All",search:""}],["RP",stats.rp,COLORS.rp,"◆",{bucket:"RP",status:"All",search:""}],["YARDI",stats.yardi,COLORS.yardi,"◇",{bucket:"YARDI",status:"All",search:""}],["Resolved",stats.resolved,COLORS.success,"✓",{bucket:"All",status:"Resolved",search:""}]].map(([l,v,c,icon,f])=>(
                <button key={l} onClick={()=>goTickets(f)} style={{padding:"14px 12px",cursor:"pointer",background:COLORS.cardBg,border:`1px solid ${COLORS.border}`,borderTop:`3px solid ${c}`,borderRadius:12,textAlign:"left",width:"100%"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div style={{fontSize:22,fontWeight:700,color:c}}>{v}</div>
                    <span style={{fontSize:14,color:c+"88"}}>{icon}</span>
                  </div>
                  <div style={{fontSize:10,color:COLORS.textMuted,marginTop:4,fontWeight:500}}>{l}</div>
                </button>
              ))}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
              <Card style={{padding:20}}>
                <div style={{fontWeight:500,marginBottom:16,color:COLORS.text,fontSize:13}}>Tickets by category</div>
                {CATEGORIES.map((cat,i)=>{
                  const n=tickets.filter(t=>t.category===cat).length;
                  const pct=Math.round((n/Math.max(tickets.length,1))*100)||0;
                  const colors=["#4f6ef7","#7c3aed","#0ea5e9","#16a34a","#d97706","#e84949"];
                  return(
                    <button key={cat} onClick={()=>goTickets({bucket:"All",status:"All",search:cat})} style={{display:"block",width:"100%",background:"none",border:"none",textAlign:"left",cursor:"pointer",marginBottom:10,padding:"4px 6px",borderRadius:6}}>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:4}}>
                        <span style={{color:COLORS.textMuted}}>{cat}</span>
                        <span style={{fontWeight:600,color:COLORS.text}}>{n}</span>
                      </div>
                      <div style={{height:8,background:COLORS.border,borderRadius:99,overflow:"hidden"}}>
                        <div style={{height:"100%",width:`${pct}%`,background:colors[i%colors.length],borderRadius:99}}></div>
                      </div>
                    </button>
                  );
                })}
              </Card>
              <Card style={{padding:20}}>
                <div style={{fontWeight:500,marginBottom:16,color:COLORS.text,fontSize:13}}>Bucket split</div>
                <div style={{display:"flex",alignItems:"center",gap:24}}>
                  <svg width="120" height="120" viewBox="0 0 120 120">
                    {(()=>{
                      const data=[["RP",stats.rp,COLORS.rp],["YARDI",stats.yardi,COLORS.yardi],["Unassigned",tickets.filter(t=>t.bucket==="Unassigned").length,"#9ca3af"]];
                      const total=data.reduce((s,[,v])=>s+v,0)||1;
                      let angle=-90;
                      return data.map(([l,v,c])=>{
                        const pct=v/total;const startAngle=angle;angle+=pct*360;
                        const r=50,cx=60,cy=60,ir=32;
                        const toRad=a=>a*Math.PI/180;
                        const x1=cx+r*Math.cos(toRad(startAngle)),y1=cy+r*Math.sin(toRad(startAngle));
                        const x2=cx+r*Math.cos(toRad(angle-0.5)),y2=cy+r*Math.sin(toRad(angle-0.5));
                        const ix1=cx+ir*Math.cos(toRad(startAngle)),iy1=cy+ir*Math.sin(toRad(startAngle));
                        const ix2=cx+ir*Math.cos(toRad(angle-0.5)),iy2=cy+ir*Math.sin(toRad(angle-0.5));
                        const large=pct>0.5?1:0;
                        return<path key={l} d={`M${ix1},${iy1} L${x1},${y1} A${r},${r} 0 ${large},1 ${x2},${y2} L${ix2},${iy2} A${ir},${ir} 0 ${large},0 ${ix1},${iy1}`} fill={c} stroke="#fff" strokeWidth="2" style={{cursor:"pointer"}} onClick={()=>goTickets({bucket:l,status:"All",search:""})}/>;
                      });
                    })()}
                    <text x="60" y="56" textAnchor="middle" fontSize="14" fontWeight="700" fill={COLORS.text}>{stats.total}</text>
                    <text x="60" y="70" textAnchor="middle" fontSize="9" fill={COLORS.textMuted}>total</text>
                  </svg>
                  <div style={{flex:1}}>
                    {[["RP",stats.rp,COLORS.rp],["YARDI",stats.yardi,COLORS.yardi],["Unassigned",tickets.filter(t=>t.bucket==="Unassigned").length,"#9ca3af"]].map(([l,v,c])=>(
                      <button key={l} onClick={()=>goTickets({bucket:l,status:"All",search:""})} style={{display:"flex",alignItems:"center",gap:8,marginBottom:10,width:"100%",background:"none",border:"none",cursor:"pointer",textAlign:"left",padding:"2px 4px",borderRadius:6}}>
                        <div style={{width:10,height:10,borderRadius:2,background:c,flexShrink:0}}></div>
                        <span style={{flex:1,fontSize:12,color:COLORS.textMuted}}>{l}</span>
                        <span style={{fontWeight:600,color:c,fontSize:13}}>{v}</span>
                        <span style={{fontSize:11,color:COLORS.textLight}}>{Math.round(v/Math.max(stats.total,1)*100)}%</span>
                      </button>
                    ))}
                  </div>
                </div>
              </Card>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:16,marginBottom:16}}>
              <Card style={{padding:20}}>
                <div style={{fontWeight:500,marginBottom:16,color:COLORS.text,fontSize:13}}>Status overview</div>
                {STATUSES.map(s=>{
                  const n=tickets.filter(t=>t.status===s).length;
                  const pct=Math.round(n/Math.max(tickets.length,1)*100)||0;
                  const map={Open:COLORS.accent,"In Progress":COLORS.warning,Pending:"#9333ea",Resolved:COLORS.success,Closed:COLORS.textMuted};
                  return(
                    <button key={s} onClick={()=>goTickets({bucket:"All",status:s,search:""})} style={{display:"block",width:"100%",background:"none",border:"none",textAlign:"left",cursor:"pointer",marginBottom:10,padding:"4px 6px",borderRadius:6}}>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:3}}>
                        <span style={{color:COLORS.textMuted}}>{s}</span>
                        <span style={{fontWeight:600,color:map[s]}}>{n} <span style={{color:COLORS.textLight,fontWeight:400}}>({pct}%)</span></span>
                      </div>
                      <div style={{height:6,background:COLORS.border,borderRadius:99,overflow:"hidden"}}>
                        <div style={{height:"100%",width:`${pct}%`,background:map[s],borderRadius:99}}></div>
                      </div>
                    </button>
                  );
                })}
              </Card>
              <Card style={{padding:20}}>
                <div style={{fontWeight:500,marginBottom:16,color:COLORS.text,fontSize:13}}>Agent workload</div>
                {AGENTS.slice(0,6).map((a,i)=>{
                  const n=tickets.filter(t=>Array.isArray(t.assignedTo)?t.assignedTo.includes(a):t.assignedTo===a).length;
                  const colors=[COLORS.accent,"#7c3aed","#0ea5e9","#16a34a","#d97706","#e84949"];
                  return(
                    <button key={a} onClick={()=>goTickets({bucket:"All",status:"All",search:a})} style={{display:"flex",alignItems:"center",gap:8,marginBottom:9,width:"100%",background:"none",border:"none",cursor:"pointer",textAlign:"left",padding:"2px 4px",borderRadius:6}}>
                      <Avatar name={a} size={22} color={colors[i%colors.length]}/>
                      <span style={{flex:1,color:COLORS.textMuted,fontSize:11}}>{a}</span>
                      <div style={{width:60,height:5,background:COLORS.border,borderRadius:99,overflow:"hidden"}}>
                        <div style={{height:"100%",width:`${Math.round(n/Math.max(tickets.length,1)*100)*3}%`,background:colors[i%colors.length],borderRadius:99}}></div>
                      </div>
                      <span style={{fontWeight:600,color:COLORS.text,fontSize:11,minWidth:14}}>{n}</span>
                    </button>
                  );
                })}
              </Card>
              <Card style={{padding:20}}>
                <div style={{fontWeight:500,marginBottom:14,color:COLORS.text,fontSize:13,display:"flex",justifyContent:"space-between"}}>
                  Recent tickets <button onClick={()=>goTickets({bucket:"All",status:"All",search:""})} style={{fontSize:11,color:COLORS.accent,background:"none",border:"none",cursor:"pointer"}}>View all →</button>
                </div>
                {tickets.slice(0,5).map(t=>(
                  <button key={t.id} onClick={()=>{setSelected(t);setPage("tickets");}} style={{display:"flex",alignItems:"center",gap:8,padding:"7px 0",borderBottom:`1px solid ${COLORS.border}`,cursor:"pointer",width:"100%",background:"none",border:"none",borderBottom:`1px solid ${COLORS.border}`,textAlign:"left"}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:11,fontWeight:500,color:COLORS.text,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{t.subject}</div>
                      <div style={{fontSize:10,color:COLORS.textMuted}}>{t.from}</div>
                    </div>
                    <div style={{display:"flex",gap:3,flexShrink:0}}>
                      {t.isVIP&&<Badge label="VIP" color={COLORS.vip} bg={COLORS.vipLight}/>}
                      {statusBadge(t.status)}
                    </div>
                  </button>
                ))}
              </Card>
            </div>
            <Card style={{padding:20}}>
              <div style={{fontWeight:500,marginBottom:16,color:COLORS.text,fontSize:13}}>Inbox activity</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
                {INBOXES.map((inbox,i)=>{
                  const n=tickets.filter(t=>t.to===inbox).length;
                  const vips=tickets.filter(t=>t.to===inbox&&t.isVIP).length;
                  const colors=[COLORS.accent,"#7c3aed","#0ea5e9","#16a34a"];
                  const pct=Math.round(n/Math.max(tickets.length,1)*100)||0;
                  return(
                    <button key={inbox} onClick={()=>goTickets({bucket:"All",status:"All",search:inbox})} style={{background:COLORS.bg,borderRadius:10,padding:"14px 16px",border:`1px solid ${COLORS.border}`,textAlign:"left",cursor:"pointer",width:"100%"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                        <div style={{fontSize:10,color:COLORS.textMuted,fontWeight:500,lineHeight:1.4}}>{inbox}</div>
                        <div style={{width:8,height:8,borderRadius:"50%",background:COLORS.success}}></div>
                      </div>
                      <div style={{fontSize:24,fontWeight:700,color:colors[i],marginBottom:4}}>{n}</div>
                      <div style={{fontSize:10,color:COLORS.textMuted,marginBottom:8}}>tickets · {vips} VIP</div>
                      <div style={{height:4,background:COLORS.border,borderRadius:99,overflow:"hidden"}}>
                        <div style={{height:"100%",width:`${pct}%`,background:colors[i],borderRadius:99}}></div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </Card>
          </>}

          {/* TICKETS */}
          {page==="tickets"&&(
            <div style={{display:"flex",gap:16}}>
              <div style={{width:340,flexShrink:0}}>
                <Card style={{padding:12,marginBottom:10}}>
                  <input value={filters.search} onChange={e=>setFilters(p=>({...p,search:e.target.value}))} placeholder="Search tickets..." style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"7px 10px",fontSize:12,outline:"none",boxSizing:"border-box",background:COLORS.bg,color:COLORS.text}}/>
                  <div style={{display:"flex",gap:8,marginTop:8}}>
                    {[["bucket",["All","RP","YARDI","Unassigned"]],["status",["All",...STATUSES]]].map(([key,opts])=>(
                      <select key={key} value={filters[key]} onChange={e=>setFilters(p=>({...p,[key]:e.target.value}))} style={{flex:1,border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"6px 8px",fontSize:11,background:COLORS.bg,color:COLORS.text,outline:"none"}}>
                        {opts.map(o=><option key={o}>{o}</option>)}
                      </select>
                    ))}
                  </div>
                  <div style={{fontSize:11,color:COLORS.textMuted,marginTop:8}}>
                    {loading?"Loading...":`${tickets.length} of ${totalTickets} tickets`}
                  </div>
                </Card>
                <div style={{display:"flex",flexDirection:"column",gap:6}}>
                  {tickets.map(t=>(
                    <button key={t.id} onClick={()=>setSelected(t)} style={{padding:12,cursor:"pointer",background:selected?.id===t.id?COLORS.accentLight:COLORS.cardBg,border:`1.5px solid ${selected?.id===t.id?COLORS.accent:COLORS.border}`,borderRadius:12,textAlign:"left",width:"100%"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
                        <span style={{fontSize:10,fontFamily:"monospace",color:COLORS.textLight}}>{t.id}</span>
                        <div style={{display:"flex",gap:4}}>
                          {t.isVIP&&<Badge label="VIP" color={COLORS.vip} bg={COLORS.vipLight}/>}
                          {bucketBadge(t.bucket)}
                        </div>
                      </div>
                      <div style={{fontWeight:500,color:COLORS.text,fontSize:12,marginBottom:3,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{t.subject}</div>
                      <div style={{fontSize:11,color:COLORS.textMuted,marginBottom:6,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{t.from}</div>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                        {statusBadge(t.status)}
                        <span style={{fontSize:10,color:COLORS.textLight}}>{Array.isArray(t.assignedTo)?t.assignedTo.join(", "):t.assignedTo}</span>
                      </div>
                    </button>
                  ))}
                  {currentPage<lastPage&&(
                    <button onClick={()=>fetchTickets(filters,currentPage+1)} style={{padding:"10px",background:COLORS.accentLight,border:`1px solid ${COLORS.accent}`,borderRadius:8,color:COLORS.accent,fontSize:12,cursor:"pointer",fontWeight:500}}>
                      Load more ({totalTickets-tickets.length} remaining)
                    </button>
                  )}
                  {!tickets.length&&!loading&&<div style={{textAlign:"center",color:COLORS.textMuted,padding:40,fontSize:12}}>No tickets found</div>}
                </div>
              </div>

              {/* RIGHT PANEL */}
              <div ref={detailRef} style={{flex:1,background:COLORS.cardBg,border:`1px solid ${COLORS.border}`,borderRadius:12,minHeight:400,overflowY:"auto",maxHeight:"calc(100vh - 120px)"}}>
                {!selected?(
                  <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100%",minHeight:400,color:COLORS.textMuted}}>
                    <div style={{textAlign:"center"}}>
                      <div style={{fontSize:36,marginBottom:8}}>◈</div>
                      <div style={{fontSize:13,marginBottom:4}}>Click any ticket to view details</div>
                      <div style={{fontSize:11,color:COLORS.textLight}}>Detail will appear here</div>
                    </div>
                  </div>
                ):(
                  <div>
                    {/* ✅ STICKY HEADER with Reply All + Actions in top right */}
                    <div style={{position:"sticky",top:0,background:COLORS.cardBg,borderBottom:`1px solid ${COLORS.border}`,padding:"12px 20px",zIndex:10,display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>
                      <button onClick={()=>setSelected(null)} style={{background:"none",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"6px 12px",fontSize:12,cursor:"pointer",color:COLORS.textMuted}}>← Back</button>
                      <span style={{fontSize:11,color:COLORS.textMuted,fontFamily:"monospace"}}>{selected.id}</span>
                      {selected.isVIP&&<Badge label="⚡ VIP" color={COLORS.vip} bg={COLORS.vipLight}/>}
                      {bucketBadge(selected.bucket)}
                      {statusBadge(selected.status)}
                      {/* Reply All + Actions on right */}
                      <div style={{marginLeft:"auto",display:"flex",gap:8}}>
                        <DropdownReply ticket={selected} showToast={showToast} onReplySent={note=>updateTicket(selected.id,{body:selected.body+note})}/>
                        <DropdownActions ticket={selected} updateTicket={updateTicket} showToast={showToast}/>
                      </div>
                    </div>

                    {/* TICKET CONTENT */}
                    <div style={{padding:20}}>
                      <h3 style={{margin:"0 0 16px",fontSize:18,fontWeight:600,color:COLORS.text}}>{selected.subject}</h3>
                      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:16}}>
                        {[["From",selected.from],["To",selected.to],["Assigned",Array.isArray(selected.assignedTo)?selected.assignedTo.join(", "):selected.assignedTo],["Category",selected.category],["Bucket",selected.bucket],["Created",new Date(selected.date).toLocaleString()]].map(([l,v])=>(
                          <div key={l} style={{background:COLORS.bg,borderRadius:8,padding:"10px 12px"}}>
                            <div style={{fontSize:10,color:COLORS.textMuted,marginBottom:2}}>{l}</div>
                            <div style={{fontSize:12,fontWeight:500,color:COLORS.text,wordBreak:"break-all"}}>{v}</div>
                          </div>
                        ))}
                      </div>

                      {/* EMAIL BODY — latest reply first */}
                      <div style={{marginBottom:16}}>
                        <div style={{fontSize:11,color:COLORS.textMuted,marginBottom:8,fontWeight:500}}>Email Thread</div>
                        {(selected.body||'').split('--- Reply from ').map((part,i,arr)=>({part,i})).reverse().map(({part,i})=>(
                          <div key={i} style={{marginBottom:10,padding:14,background:i===0?COLORS.bg:"#f0f4ff",borderRadius:8,border:`1px solid ${i===0?COLORS.border:COLORS.accent+"44"}`}}>
                            {i>0&&(
                              <div style={{fontSize:11,fontWeight:600,color:COLORS.accent,marginBottom:8,paddingBottom:6,borderBottom:`1px solid ${COLORS.border}`}}>
                                💬 Reply from {part.split(' ---')[0]}
                              </div>
                            )}
                            <pre style={{margin:0,fontSize:12,color:COLORS.text,lineHeight:1.8,fontFamily:"system-ui,sans-serif",whiteSpace:"pre-wrap",wordBreak:"break-word"}}>
                              {(i>0?part.substring(part.indexOf('---\n')+4):part).replace(/\n{3,}/g,'\n\n').trim()}
                            </pre>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* INBOXES */}
          {page==="inboxes"&&(
            <div style={{maxWidth:600}}>
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {INBOXES.map(inbox=>{
                  const n=tickets.filter(t=>t.to===inbox).length;
                  return(
                    <Card key={inbox} style={{padding:16,display:"flex",alignItems:"center",gap:14}}>
                      <div style={{width:36,height:36,borderRadius:9,background:COLORS.accentLight,display:"flex",alignItems:"center",justifyContent:"center",color:COLORS.accent,fontSize:16}}>✉</div>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:500,color:COLORS.text}}>{inbox}</div>
                        <div style={{fontSize:11,color:COLORS.textMuted,marginTop:2}}>{n} ticket{n!==1?"s":""}</div>
                      </div>
                      <Badge label="Synced" color={COLORS.success} bg={COLORS.successLight}/>
                    </Card>
                  );
                })}
              </div>
            </div>
          )}

          {/* AGENTS */}
          {page==="agents"&&(
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))",gap:12}}>
              {AGENTS.map((agent,i)=>{
                const at=tickets.filter(t=>Array.isArray(t.assignedTo)?t.assignedTo.includes(agent):t.assignedTo===agent);
                const open=at.filter(t=>t.status==="Open").length;
                const colors=[COLORS.accent,"#7c3aed","#0ea5e9","#16a34a","#d97706","#e84949","#9333ea","#0891b2"];
                return(
                  <Card key={agent} style={{padding:16}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
                      <Avatar name={agent} size={36} color={colors[i%colors.length]}/>
                      <div>
                        <div style={{fontWeight:500,color:COLORS.text}}>{agent}</div>
                        <div style={{fontSize:11,color:COLORS.textMuted}}>AP Agent</div>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:6}}>
                      <Badge label={`${at.length} total`} color={COLORS.textMuted} bg={COLORS.bg}/>
                      <Badge label={`${open} open`} color={colors[i%colors.length]} bg={colors[i%colors.length]+"18"}/>
                    </div>
                  </Card>
                );
              })}
            </div>
          )}

          {page==="users"&&<UsersPage/>}
          {page==="properties"&&<PropertiesPage/>}

          {/* REPORTS */}
          {page==="reports"&&<>
            <div style={{display:"flex",gap:12,marginBottom:20,flexWrap:"wrap"}}>
              {[["Total Tickets",totalTickets,COLORS.accent],["Resolved",stats.resolved,COLORS.success],["VIP Tickets",stats.vip,COLORS.vip],["Avg per inbox",(totalTickets/4).toFixed(0),COLORS.warning]].map(([l,v,c])=>(
                <Card key={l} style={{padding:"14px 18px",flex:1,minWidth:110}}>
                  <div style={{fontSize:26,fontWeight:600,color:c}}>{v}</div>
                  <div style={{fontSize:11,color:COLORS.textMuted,marginTop:2}}>{l}</div>
                </Card>
              ))}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
              <Card style={{padding:20}}>
                <div style={{fontWeight:500,marginBottom:16,color:COLORS.text}}>Tickets by bucket</div>
                {[["RP",stats.rp,"#7c3aed"],["YARDI",stats.yardi,"#0ea5e9"],["Unassigned",tickets.filter(t=>t.bucket==="Unassigned").length,"#9ca3af"]].map(([l,v,c])=>(
                  <div key={l} style={{marginBottom:12}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                      <span style={{fontSize:12,color:COLORS.textMuted}}>{l}</span>
                      <span style={{fontSize:12,fontWeight:500}}>{v} ({Math.round(v/Math.max(tickets.length,1)*100)}%)</span>
                    </div>
                    <div style={{height:8,background:COLORS.border,borderRadius:99,overflow:"hidden"}}>
                      <div style={{height:"100%",width:`${Math.round(v/Math.max(tickets.length,1)*100)}%`,background:c,borderRadius:99}}></div>
                    </div>
                  </div>
                ))}
              </Card>
              <Card style={{padding:20}}>
                <div style={{fontWeight:500,marginBottom:16,color:COLORS.text}}>Agent workload</div>
                {AGENTS.map((a,i)=>{
                  const n=tickets.filter(t=>Array.isArray(t.assignedTo)?t.assignedTo.includes(a):t.assignedTo===a).length;
                  const colors=[COLORS.accent,"#7c3aed","#0ea5e9","#16a34a","#d97706","#e84949","#9333ea","#0891b2"];
                  return(
                    <div key={a} style={{marginBottom:10}}>
                      <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                        <span style={{fontSize:12,color:COLORS.textMuted}}>{a}</span>
                        <span style={{fontSize:12,fontWeight:500}}>{n}</span>
                      </div>
                      <div style={{height:6,background:COLORS.border,borderRadius:99,overflow:"hidden"}}>
                        <div style={{height:"100%",width:`${Math.round(n/Math.max(tickets.length,1)*100)}%`,background:colors[i%colors.length],borderRadius:99}}></div>
                      </div>
                    </div>
                  );
                })}
              </Card>
            </div>
          </>}

        </div>
      </div>

      {compose&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.4)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200}}>
          <Card style={{width:460,padding:24}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
              <div style={{fontWeight:500,fontSize:15,color:COLORS.text}}>Simulate incoming email</div>
              <button onClick={()=>setCompose(false)} style={{background:"none",border:"none",cursor:"pointer",fontSize:18,color:COLORS.textMuted}}>×</button>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {[["From","from","text","sender@company.com"],["Subject","subject","text","e.g. URGENT: Lien Notice - Yardi"]].map(([l,k,t,ph])=>(
                <div key={k}>
                  <div style={{fontSize:11,color:COLORS.textMuted,marginBottom:4}}>{l}</div>
                  <input type={t} value={draft[k]} onChange={e=>setDraft(p=>({...p,[k]:e.target.value}))} placeholder={ph} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:12,outline:"none",boxSizing:"border-box",background:COLORS.bg,color:COLORS.text}}/>
                </div>
              ))}
              <div>
                <div style={{fontSize:11,color:COLORS.textMuted,marginBottom:4}}>To (inbox)</div>
                <select value={draft.to} onChange={e=>setDraft(p=>({...p,to:e.target.value}))} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:12,background:COLORS.bg,color:COLORS.text,outline:"none"}}>
                  {INBOXES.map(i=><option key={i}>{i}</option>)}
                </select>
              </div>
              <div>
                <div style={{fontSize:11,color:COLORS.textMuted,marginBottom:4}}>Body</div>
                <textarea value={draft.body} onChange={e=>setDraft(p=>({...p,body:e.target.value}))} placeholder="Email body..." rows={4} style={{width:"100%",border:`1px solid ${COLORS.border}`,borderRadius:8,padding:"8px 10px",fontSize:12,outline:"none",resize:"vertical",fontFamily:"inherit",boxSizing:"border-box",background:COLORS.bg,color:COLORS.text}}/>
              </div>
              <div style={{display:"flex",gap:8,paddingTop:4}}>
                <button onClick={()=>setCompose(false)} style={{flex:1,border:`1px solid ${COLORS.border}`,background:"transparent",color:COLORS.textMuted,borderRadius:8,padding:"8px",fontSize:12,cursor:"pointer"}}>Cancel</button>
                <button onClick={submitEmail} style={{flex:1,background:COLORS.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px",fontSize:12,fontWeight:500,cursor:"pointer"}}>Send & Create Ticket</button>
              </div>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}